export enum  REFRESH_INDEXED {
    NEVER = 1,
    ALWAYS = 2,
    EVERY_REFRESH = 3,
    EVERY_DAY = 4,
}

export enum DIAS_SEMANA {
  DOMINGO = 7,
  LUNES = 1,
  MARTES = 2,
  MIERCOLES = 3,
  JUEVES = 4,
  VIERNES = 5,
  SABADO = 6
}
